import * as React from "react";
import { useTheme, Box, Typography, Stack } from "@mui/material";
import { animateScroll as scroll } from "react-scroll";
import { ArrowUpward } from "@mui/icons-material";

const ScrollTop = ({}) => {
  const theme = useTheme();

  const [mover, setMover] = React.useState(
    Math.round((Math.random() * 40) / 10)
  );

  const handleSrollTop = (event) => {
    event.preventDefault();
    scroll.scrollToTop();
  };

  return (
    <Stack
      sx={{
        p: "2.5rem",
        pl: "30%",
        position: "fixed",
        bottom: "0rem",
        right: "Orem",
        left: "Orem",
        borderRadius: "10px 10px Opx 0px",
        alignItems: "flex-start",
        width: "100%",
        justifyContent: "center",
        zIndex: "900",
      }}
    >
      <Box
        onClick={handleSrollTop}
        onMouseEnter={() => setMover(Math.round((Math.random() * 40) / 10))}
        sx={{
          bgcolor: theme.palette.common.white,
          borderRadius: "50%",
          overflow: "hidden",
          zIndex: 800,
          boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 8%)",
          p: "0.3rem",
          transition: "all .3s",
          transform: "translateY(-15px, -15px)",

          "&:hover": {
            cursor: "pointer",
            transition: "all .3s",
            transform: [4, 2].includes(mover)
              ? `translateX(${mover === 2 ? 25 : -25}px)`
              : `translateY(${mover === 3 ? 25 : -25}px)`,
          },
        }}
      >
        <ArrowUpward
          sx={{
            color: theme.palette.common.black,
            fontSize: "18px",
            mt: "0.25rem",
            mx: "0.4rem",
          }}
        />
      </Box>
    </Stack>
  );
};

export default ScrollTop;
